import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'

import { simpleText } from './animations'
import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type SimpleTextProps = HTMLAttributes<HTMLElement> &
  Partial<{
    paragraph: string
    theme: WPPageData['acf']['theme']
  }>

const SimpleText = ({ paragraph, theme, ...props }: SimpleTextProps) => {
  return paragraph ? (
    <Motion animation={simpleText}>
      {(motionRef) => (
        <section
          ref={motionRef}
          {...props}
          className={cn([
            {
              'bg-dark-100 text-dark-500': theme === 'light',
              'bg-dark-600 text-white': theme === 'dark'
            }
          ])}
        >
          <Container>
            <Grid>
              <div
                className={cn(
                  'col-span-4',
                  'md:col-span-6',
                  'lg:col-start-4',
                  'text-center'
                )}
              >
                <Typography variant="h2" component="h2" data-motion-paragraph>
                  {paragraph}
                </Typography>
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  ) : null
}

export default SimpleText
